import React from 'react';
import { Modal, Button, Form, Input } from 'antd';

const DeleteOrderModal = ({
    isConfirmDeleteModalOpen,
    handleDeleteCancel,
    confirmDeleteData,
    isLastBillInOrder,
    formRef2,
    handleDeleteConfirm
}) => {
    return (
        <Modal width={500} title="ยืนยันการลบ" open={isConfirmDeleteModalOpen} onCancel={handleDeleteCancel} footer={false}>

            <p>Bill ID: {confirmDeleteData?.id}</p>
            <p>ORDER ID: {confirmDeleteData?.order_id}</p>
            <p>ราคาที่จ่าย: {confirmDeleteData?.price_to_paid} บาท</p>
            {isLastBillInOrder && <p className='text-red-500 font-bold'> คุณกำลังลบบิลอันสุดท้าย ซึ่งจะทำให้สินค้านี้ถูกลบไปทั้งหมด</p>}

            <Form
                name="basic"
                form={formRef2}
                initialValues={{
                    remember: true,
                }}
                onFinish={handleDeleteConfirm}
                autoComplete="off"
            >

                <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                        {
                            required: true,
                            message: 'Please input your password!',
                        },
                    ]}
                >
                    <Input.Password />
                </Form.Item>


                <div className='flex gap-2 justify-center'>
                    <Form.Item
                    >
                        <Button htmlType="submit" >
                            ตกลง
                        </Button>
                        <Button onClick={handleDeleteCancel} >
                            ยกเลิก
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
    );
};

export default DeleteOrderModal;
